import React from "react";
import PropTypes from "prop-types";
import "./Grid.scss";

// components
import Grid from "../../coraWebComponents/grid/GridWrapper";
import flags from "../../coraWebComponents/utils/flags";
import Detail from "./Detail";

class ZISGridComponent extends React.Component {
  constructor(props) {
    super(props);

    this.defaults = {
      hidden: flags.ADD | flags.COPY | flags.DELETE | flags.CANCEL | flags.RESET | 
        flags.EDIT | flags.EDITALL | flags.COLUMN_MENU | flags.COLUMN_SELECTED | flags.USER_FILTER  | flags.SORT_DIALOG,
      detail: Detail({ detailSchema: props.detailSchema }),
    };
  }

  detailHandle = () => {
    let { detail, detailSchema } = this.props;

    if (detail === undefined) {
      detail = detailSchema ? this.defaults.detail : null;
    }

    return detail;
  };

  render() {
    const {
      data,
      isLoading,
      onChange,
      onExpandChange,
      onGet,
      onGetList,
      onRowDoubleClick,
      onSelect,
      primaryField,
      schema,
      total,
      noRecords,
      hidden,
      allColumns,
      disabled,
      cellRender,
      toolbarActions,
      className,
      multiple,
      printable,
      cellSelect,
      fixedFilter,
      initSort,
    } = this.props;

    const media = window.matchMedia('only screen and (min-width: 768px)');

    return (
      <Grid
        className={ (className ? className : "") + (media.matches ? "" : " mobile") }
        data={data}
        detail={this.detailHandle()}
        isLoading={isLoading}
        onChange={onChange}
        onExpandChange={onExpandChange}
        onGet={onGet}
        onGetList={onGetList}
        onRowDoubleClick={onRowDoubleClick}
        onSelect={onSelect}
        primaryField={primaryField}
        schema={schema}
        total={total}
        noRecords={noRecords}
        hidden={hidden ? hidden | this.defaults.hidden : this.defaults.hidden}
        allColumns={allColumns}
        disabled={disabled}
        cellRender={cellRender}
        toolbarActions={toolbarActions}
        multiple={multiple}
        printable={printable}
        cellSelect={cellSelect}
        fixedFilter={fixedFilter}
        initSort={initSort}
      />
    );
  }
}

ZISGridComponent.propTypes = {
  data: PropTypes.array.isRequired,
  detail: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onExpandChange: PropTypes.func,
  onGet: PropTypes.func.isRequired,
  onGetList: PropTypes.func.isRequired,
  onRowDoubleClick: PropTypes.func,
  onSelect: PropTypes.func,
  primaryField: PropTypes.string.isRequired,
  schema: PropTypes.array.isRequired,
  detailSchema: PropTypes.array,
  total: PropTypes.number.isRequired,
  noRecords: PropTypes.string,
  hidden: PropTypes.number,
  allColumns: PropTypes.bool,
  disabled: PropTypes.number,
  cellRender: PropTypes.func,
  toolbarActions: PropTypes.func,
  className: PropTypes.string,
  multiple: PropTypes.bool,
  printable: PropTypes.bool,
  cellSelect: PropTypes.bool,
  fixedFilter: PropTypes.object, 
  initSort: PropTypes.array,
};

export default ZISGridComponent;
